import { render, staticRenderFns } from "./eleWaybillDetail.vue?vue&type=template&id=edebbd14&scoped=true&"
import script from "./eleWaybillDetail.vue?vue&type=script&lang=js&"
export * from "./eleWaybillDetail.vue?vue&type=script&lang=js&"
import style0 from "./eleWaybillDetail.vue?vue&type=style&index=0&id=edebbd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edebbd14",
  null
  
)

export default component.exports